/* Pearled Ivory — reviews overlay stacking fix.
   The custom #pi-reviews-overlay is rendered inside the sticky <product-info>
   column; position:sticky creates a stacking context that traps the overlay's
   position:fixed, letting the product image paint over its left half. Moving the
   overlay to <body> restores correct full-screen centering. Additive + reversible. */
(function () {
  function moveOverlay() {
    var ov = document.getElementById('pi-reviews-overlay');
    if (ov && ov.parentNode !== document.body) {
      document.body.appendChild(ov);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveOverlay);
  } else {
    moveOverlay();
  }
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('#pi-rating')) {
      setTimeout(moveOverlay, 0);
    }
  }, true);
})();

/* Pearled Ivory — rectangular buttons (2026-10-29): stop pi-cart.js pill rounding and clear what it already set. */
(function () {
  window.PI_ROUND_BTNS = false;
  function square() {
    document.querySelectorAll('.product-form__submit, .product-form__buttons button[name="add"], shop-pay-wallet-button, [is="shop-pay-wallet-button"]').forEach(function (b) {
      if (b.style.getPropertyValue('border-radius') === '999px') b.style.setProperty('border-radius', '0px', 'important');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', square); else square();
  window.addEventListener('load', square);
  setTimeout(square, 1500);
})();

/* Pearled Ivory — product-page layer, loaded on product pages only:
   pi-mobile-pdp (mobile layout + bottom buy panel), pi-photo-ext (phone photo backgrounds)
   and pi-complete-look (category tabs). Bump VERSION after editing any of these files (the CDN caches by ?v=). */
(function () {
  var VERSION = '20261103-32';
  var me = document.currentScript;
  if (!me || !me.src) return;
  var base = me.src.split('pi-reviews-fix.js')[0];
  function css(name) { var l = document.createElement('link'); l.id = name + '-css'; l.rel = 'stylesheet'; l.href = base + name + '.css?v=' + VERSION; document.head.appendChild(l); }
  function js(name) { var j = document.createElement('script'); j.src = base + name + '.js?v=' + VERSION; document.body.appendChild(j); }
  /* Phones: "1 / 7" photo counter, and hide the stand-alone "Model:" line when the description already lists it. */
  function extras() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    var ul = document.querySelector('.product__media-list');
    if (ul && !document.querySelector('.pi-count')) {
      var n = ul.querySelectorAll(':scope > .product__media-item').length;
      if (n > 1) {
        var host = ul.closest('slider-component') || ul.parentElement;
        var c = document.createElement('span'); c.className = 'pi-count'; host.appendChild(c);
        var upd = function () { var i = Math.round(ul.scrollLeft / (ul.clientWidth || 1)) + 1; c.textContent = Math.min(Math.max(i, 1), n) + ' / ' + n; };
        ul.addEventListener('scroll', upd, { passive: true }); upd();
      }
    }
    var p = document.querySelector('.product__info-container p.product__text');
    var d = document.querySelector('.pi-desc-inline') || document.querySelector('.oc-tabs-container');
    if (p && /^\s*model\s*:/i.test(p.textContent) && d && /model/i.test(d.textContent)) p.classList.add('pi-model-line');
  }
  function load() {
    if (!/\btemplate-product\b/.test(document.body.className) || document.getElementById('pi-mobile-pdp-css')) return;
    css('pi-mobile-pdp'); js('pi-mobile-pdp'); js('pi-photo-ext');
    css('pi-complete-look'); js('pi-complete-look');
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', extras); else extras();
    window.addEventListener('load', extras);
  }
  if (document.body) load(); else document.addEventListener('DOMContentLoaded', load);
})();